import { render, staticRenderFns } from "./SupportPageCard.vue?vue&type=template&id=431512d2&"
import script from "./SupportPageCard.vue?vue&type=script&lang=js&"
export * from "./SupportPageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports